(function() {
	'use strict';

	[].map.call(document.querySelectorAll('.MainMenu-dropDownWrap'), function (item) {
		var timer;
		item.addEventListener('mouseover', function(event) {
			item.classList.add('hover');
			clearTimeout(timer);
		});
		item.addEventListener('mouseout', function(event) {
			timer = setTimeout(function() {
				item.classList.remove('hover');
			}, 500);
		});
	});

}());
